import { smartTagSettingSelector } from "./smartTagSettingSelector";
import { RootState } from "../../store";

export const smartTagCustomValueSelector = (state: RootState) => {
  const settings = smartTagSettingSelector(state);

  return settings?.data?.value || "";
};
